<template>
  <b-dropdown :id="id" :class="[dropdownGroup ? 'dropdown-group-custom' : 'dropdown-item-custom', customClass]"
    :right="right" v-click-outside="onClickOutSide" :ref="refDropDown">
    <template #button-content>
      <slot name="buttonContent">
      </slot>
    </template>
    <template>
      <slot name="dropdownItems"></slot>
    </template>
  </b-dropdown>
</template>
<script>
export default {
  props: {
    id: {
      type: String,
      default: ''
    },
    dropdownGroup: {
      type: Boolean,
      default: false
    },
    refDropDown: {
      type: String
    },
    customClass: {
      type: String | Array
    },
    right: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    onClickOutSide() {
      this.$emit('onClickOutSide')
    },
    onClickRoute(event, routeName) {
      this.$emit('onClickRoute', event, routeName)
    }
  }
}
</script>
<style lang="scss" scoped>
div.b-dropdown.btn-group {
  /deep/ .btn.dropdown-toggle {
    background-color: inherit;
    border: none;
    border-radius: 80px;

    &:hover {
      background: rgba(255, 255, 255, 0.16);
      border-radius: 80px;
    }
  }
}

.dropdown-group-custom {
  width: 100%;
  height: 48px;
  padding: 8px;
  margin-bottom: 16px;

  /deep/ .btn {
    padding: 0px !important;
    text-align: left;
    position: relative;

    &::after {
      color: black;
      position: absolute;
      top: 50%;
      right: 8px;
      transform: translateY(-50%);
      border-top: 6px solid;
      border-right: 5px solid transparent;
      border-bottom: 0;
      border-left: 5px solid transparent
    }
  }

  /deep/ .dropdown-menu {
    padding-left: 8px !important;
    padding-top: 8px !important;
    padding-bottom: 8px !important;
    border: 1px solid #D6D6D6;
    box-shadow: 0px 4px 10px rgba(51, 51, 51, 0.12);
    border-radius: 8px;
    width: 229px !important;

    .dropdown-header {
      padding-left: 0px !important;
      @include responsive-fs(12);
      color: #8A8988;
      font-weight: 700;
    }

    .dropdown-item {
      padding-left: 4px;
      @include responsive-fs(14);
      position: relative;

      i {
        position: absolute;
        top: 2px;
        right: 8px;
      }
    }
  }
}

.dropdown-item-custom {
  &-button {
    display: inline-flex;
    align-items: center;
    @include responsive-fs(12);
    line-height: 0;
    color: #fff !important;
    text-align: right !important;
    vertical-align: middle !important;
  }

  /deep/ .dropdown-toggle {
    display: flex;
    align-items: center;
    padding: 8px;

    &::after {
      margin-left: 6px;
      border-top: 6px solid;
      border-right: 5px solid transparent;
      border-bottom: 0;
      border-left: 5px solid transparent;
    }
  }

  /deep/ .dropdown-menu {
    width: 137px;
    border: 1px solid #D6D6D6;
    box-shadow: 0px 4px 10px rgba(51, 51, 51, 0.12);
    border-radius: 8px;

    li {
      padding-left: 12px !important;

      &:hover {
        background-color: #e9ecef;
      }

      &:first-child {
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
      }

      &:last-child {
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
      }

      .dropdown-item {
        display: flex;
        align-items: center;
        @include responsive-fs(14);
        padding-left: 4px !important;
        padding: 8px 0px !important;

        &:hover {
          background: none !important;
        }

        i {
          flex-grow: 1;
        }
      }

      .dropdown-divider {
        margin: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/custom-components/DropdownComponent.vue